import React, { FunctionComponent } from "react"
import { useTranslation } from "react-i18next"

import noResultsImg from "assets/img/no-results.svg"

import Text from "components/Text/Text"
import Button from "components/Button/Button"

interface ISelectSearchArticleNotFound {
    onCreateArticleClick(): void
}

const SelectSearchArticleNotFound: FunctionComponent<React.PropsWithChildren<ISelectSearchArticleNotFound>> = ({
    onCreateArticleClick
}) => {
    const { t } = useTranslation()
    return (
        <div className="text-center p-3">
            <img src={noResultsImg} alt="" aria-hidden />
            <Text type="p" className="mt-2">{t('asset.selectArticle.notFound')}</Text>
            <Button
                className="mt-3"
                onClick={onCreateArticleClick}
                label={t('asset.selectArticle.addArticle')}
                data-testid="article-not-found-add-article-btn" />
        </div>
    )
}

export default SelectSearchArticleNotFound
